import { env } from '@/src/config/env'

export const candleDuration = env.EXPO_PUBLIC_APP_VARIANT === 'prod' ? 15000 : 5000

export const candleClassName = env.EXPO_PUBLIC_APP_VARIANT === 'prod' ? 'animate-candle_15000' : 'animate-candle_5000'
